// @flow
import { toastr } from "react-redux-toastr";
import { makeApiCall } from "../../../../../services/apiService/apiService";

export const categorySettingsActions = {
  GET_GROUP_TYPES_BY_BU: "GET_GROUP_TYPES_BY_BU",
  GET_TICKET_TYPES_BY_BU_AND_GROUP_TYPE:
    "GET_TICKET_TYPES_BY_BU_AND_GROUP_TYPE",
  CREATE_CATEGORY: "CREATE_CATEGORY",
  CREATE_ISSUE: "CREATE_ISSUE",
  DELETE_ISSUE: "DELETE_ISSUE"
};

export const getGroupTypesByBuAction = (data: boolean) => ({
  type: categorySettingsActions.GET_GROUP_TYPES_BY_BU,
  payload: data
});

export const getTicketTypesByBuAndGroupTypeAction = (data: boolean) => ({
  type: categorySettingsActions.GET_TICKET_TYPES_BY_BU_AND_GROUP_TYPE,
  payload: data
});

export const createCategorySubmitAction = (obj: Object) => ({
  type: categorySettingsActions.CREATE_CATEGORY,
  payload: obj
});

export const createIssueSubmitAction = (obj: Object) => ({
  type: categorySettingsActions.CREATE_ISSUE,
  payload: obj
});

export const deleteIssueAction = (obj: Object) => ({
  type: categorySettingsActions.DELETE_ISSUE,
  payload: obj
});

const getGroupTypesByBuDefaultAction = () => (dispatch: Function) => {
  dispatch(
    getGroupTypesByBuAction({
      isLoading: false,
      isLoaded: true,
      data: []
    })
  );
};

const getTicketTypesByBuAndGroupTypeDefaultAction = () => (
  dispatch: Function
) => {
  dispatch(
    getTicketTypesByBuAndGroupTypeAction({
      isLoading: false,
      isLoaded: true,
      data: []
    })
  );
};

export const getGroupTypesByBu = buId => (dispatch: Function) => {
  dispatch(
    getGroupTypesByBuAction({
      isLoading: true,
      isLoaded: false,
      data: []
    })
  );
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "getGroupTypesByBu",
    pathVariables: [
      {
        key: "#buId",
        val: buId
      }
    ],
    successCb: res => {
      //  eslint-disable-next-line
      console.log("Fetched group types ", res);
      if (res.status === "SUCCESS") {
        const data = {
          isLoading: false,
          isLoaded: true,
          data: res.response
        };
        dispatch(getGroupTypesByBuAction(data));
      } else if (res.status === "FAILURE") {
        dispatch(getGroupTypesByBuDefaultAction());
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in fetching group types, res= ", res);
      dispatch(getGroupTypesByBuDefaultAction());
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Exception in fetching group types ", res);
      dispatch(getGroupTypesByBuDefaultAction());
    }
  };
  makeApiCall(requestObj);
};

export const getTicketTypesByBuAndGroupType = (buId, groupTypeId) => (
  dispatch: Function
) => {
  dispatch(
    getTicketTypesByBuAndGroupTypeAction({
      isLoading: true,
      isLoaded: false,
      data: []
    })
  );
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "getTicketTypesByBuAndGroupType",
    pathVariables: [{ key: "#id", val: groupTypeId }],
    successCb: res => {
      //  eslint-disable-next-line
      console.log("Fetched ticket types ", res);
      if (res.status === "SUCCESS") {
        const data = {
          isLoading: false,
          isLoaded: true,
          data: res.response
        };
        dispatch(getTicketTypesByBuAndGroupTypeAction(data));
      } else if (res.status === "FAILURE") {
        dispatch(getTicketTypesByBuAndGroupTypeDefaultAction());
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in fetching ticket types, res= ", res);
      dispatch(getTicketTypesByBuAndGroupTypeDefaultAction());
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Exception in fetching ticket types ", res);
      dispatch(getTicketTypesByBuAndGroupTypeDefaultAction());
    }
  };
  makeApiCall(requestObj);
};

export const createCategorySubmit = (formData: Object, isEdit: Boolean) => (
  dispatch: Function
) => {
  dispatch(
    createCategorySubmitAction({
      isLoading: true,
      isLoaded: false,
      data: null,
      allowAPIcall: false
    })
  );

  // eslint-disable-next-line
  console.log("Category Data: ", formData);
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "ticketingCategory",
    method: isEdit ? "PUT" : "POST",
    data: formData,
    successCb: res => {
      //  eslint-disable-next-line
      console.log("Fetched Category Create Submit ", res);
      if (res.status === "SUCCESS") {
        dispatch(
          createCategorySubmitAction({
            isLoading: false,
            isLoaded: true,
            data: res.response,
            allowAPIcall: false
          })
        );
      } else if (res.status === "FAILURE") {
        dispatch(
          createCategorySubmitAction({
            isLoading: false,
            isLoaded: true,
            data: null,
            allowAPIcall: true
          })
        );
        toastr.error(res.errorMessage || "Create category failed");
      }
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log("Failure in Category submit, res = ", res);
      dispatch(
        createCategorySubmitAction({
          isLoading: false,
          isLoaded: true,
          data: null,
          allowAPIcall: true
        })
      );
      toastr.error(res.errorMessage || "Create category failed");
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log("Exception in category submit, res = ", res);
      dispatch(
        createCategorySubmitAction({
          isLoading: false,
          isLoaded: true,
          data: null,
          allowAPIcall: true
        })
      );
      toastr.error(res.errorMessage || "Create category failed");
    }
  };
  makeApiCall(requestObj);
};

export const createIssueSubmit = (formData: Object, isEdit: Boolean) => (
  dispatch: Function
) => {
  dispatch(
    createIssueSubmitAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "ticketingIssue",
    method: isEdit ? "PUT" : "POST",
    data: formData,
    successCb: res => {
      if (res.status === "SUCCESS") {
        dispatch(
          createIssueSubmitAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
      } else if (res.status === "FAILURE") {
        toastr.error("Failure", res.errorMessage, {
          timeout: 3000
        });
        dispatch(
          createIssueSubmitAction({
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
      }
    },
    failureCb: res => {
      toastr.error("Failure", res.errorMessage, {
        timeout: 3000
      });
      dispatch(
        createIssueSubmitAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    },
    catchCb: res => {
      toastr.error("Failure", res.errorMessage, {
        timeout: 3000
      });
      dispatch(
        createIssueSubmitAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    }
  };
  makeApiCall(requestObj);
};

export const deleteIssue = (formData: Object) => (dispatch: Function) => {
  dispatch(
    deleteIssueAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "deleteIssue",
    method: "DELETE",
    pathVariables: [{ key: "#id", val: formData.id }],
    successCb: res => {
      if (res.status === "SUCCESS") {
        toastr.success("Issue type deleted successfully");
        dispatch(
          deleteIssueAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
      } else if (res.status === "FAILURE") {
        toastr.error("Failure", res.errorMessage, {
          timeout: 3000
        });
        dispatch(
          deleteIssueAction({
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
      }
    },
    failureCb: res => {
      toastr.error("Failure", res.errorMessage, {
        timeout: 3000
      });
      dispatch(
        deleteIssueAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    },
    catchCb: res => {
      toastr.error("Failure", res.errorMessage, {
        timeout: 3000
      });
      dispatch(
        deleteIssueAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    }
  };
  makeApiCall(requestObj);
};



// WEBPACK FOOTER //
// ./app/components/containers/ticketing/categorySettings/categorySettingsRedux/categorySettingsActionCreator.js